import React from "react";
import "./laboratoriesSection.css";
import { FaHeartbeat, FaStoreAlt } from "react-icons/fa";

const labsAndShops = [
  {
    name: "Healthy Life Lab",
    desc: "Providing comprehensive diagnostics and accurate test results.",
    type: "Lab",
  },
  {
    name: "MediCare Medical Store",
    desc: "Your one-stop destination for prescription medications.",
    type: "Medical Shop",
  },
  {
    name: "City Diagnostic Centre",
    desc: "Advanced lab testing with fast results and home sample collection.",
    type: "Lab",
  },
  {
    name: "HealthMart Pharmacy",
    desc: "We deliver your prescribed medications at your doorstep.",
    type: "Medical Shop",
  },
];

function LaboratoriesSection() {
  return (
    <section id="lab_&_medicalshops" className="laboratoriesSection">
      <h2>Laboratories & Medical Shops</h2>
      <p className="section-subtitle">
        Get lab tests or order medicines with just a few clicks.
      </p>

      <div className="labs-shops-grid">
        {labsAndShops.map((item, index) => (
          <div className="labs-shops-card" key={index}>
            <div className="labs-shops-logo">
              {item.type === "Lab" ? <FaHeartbeat /> : <FaStoreAlt />}
            </div>
            <div className="labs-shops-details">
              <div className="labs-shops-type">{item.type}</div>
              <h3>{item.name}</h3>
              <p>{item.desc}</p>
              <div className="labs-shops-buttons">
                {item.type === "Lab" ? (
                  <button className="btn-filled">Book Test</button>
                ) : (
                  <button className="btn-filled">Order Medicine</button>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default LaboratoriesSection;
